import React from 'react';
import PropTypes from 'prop-types';

import { Topbar } from '../design';

const Layout = ({ children }) => {
  return (
    <>
      <Topbar />
      {children}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node
};

Layout.defaultProps = {
  children: null
};

export default Layout;
